import { where, orderBy, arrayUnion, arrayRemove } from 'firebase/firestore';
import type { MedicalModule, ModuleType } from '@flintmint/core-shared/firestore/schemas';

import { createFirestoreCrudService } from './firestore-crud-service';

export const COLLECTION_NAME = 'medicalModules';

export interface MedicalModuleWithId extends MedicalModule {
  id: string;
}

export type MedicalModuleInput = Omit<MedicalModule, 'createdAt' | 'updatedAt' | 'updatedBy'>;

const modulesService = createFirestoreCrudService<MedicalModule, MedicalModuleInput>({
  collectionName: COLLECTION_NAME,
  entityName: 'Module',
  subscribeName: 'subscribeToModules',
});

export const createModule = modulesService.create;

export const updateModule = modulesService.update;

export const deleteModule = modulesService.remove;

export const setModulesEnabled = (ids: string[], enabled: boolean, userEmail: string) =>
  modulesService.updateMany(ids, { enabled }, userEmail);

// arrayUnion/arrayRemove touch only this flow id, so a concurrent chip edit on the same module is not overwritten.
export const addFlowToModules = (ids: string[], flowId: string, userEmail: string) =>
  modulesService.updateMany(ids, { flowIds: arrayUnion(flowId) }, userEmail);

export const removeFlowFromModules = (ids: string[], flowId: string, userEmail: string) =>
  modulesService.updateMany(ids, { flowIds: arrayRemove(flowId) }, userEmail);

export function subscribeToModules(
  types: ModuleType[],
  onData: (modules: MedicalModuleWithId[]) => void,
  onError: (error: Error) => void
): () => void {
  return modulesService.subscribe(
    [where('type', 'in', types), orderBy('type', 'desc'), orderBy('name')],
    onData,
    onError,
    ` for types ${types.join(', ')}`
  );
}
